import React from 'react';
import { Link } from 'react-router-dom';
import { ADAWidgitRoles } from '../../../models/ADA';

import './LearnMoreLink.scss';

const LearnMoreLink = ({ text, altText, to, style, className, external, specialAltText }) => {
  const innerText = !specialAltText ? text : <span><span className="learn-more-special-alt-text">{specialAltText}</span><span aria-hidden="true">{text}</span></span>
  return external
  ? 
  (
    <a className={`learn-more-link ${className ? className : ''}`} aria-label={altText ? altText : null} role={ADAWidgitRoles.Link} href={to} style={style} target="_blank">{innerText}</a>
  )
  :
  (
    <Link className={`learn-more-link ${className ? className : ''}`} aria-label={altText ? altText : null} to={to} style={style}>{innerText}</Link>
  );
};

export default LearnMoreLink;
